import React from "react";

import { Col, Container, Image, Row } from "react-bootstrap";

import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import BottleCycleScreen from "../components/screens/BottleCycle.component";
import ConstructionSolutionScreen from "../components/screens/ConstructionSolution.component";
import PakVertPanelsScreen from "../components/screens/PakVertPanels.component";
import TechnologyScreen from "../components/screens/Technology.component";
import i18n from "../i18n";

const Technology = () => {
  const { t } = i18n;

  return (
    <React.Fragment>
      <DocumentComponent title={t("technology")} />

      <TechnologyScreen />

      <PakVertPanelsScreen />

      <ConstructionSolutionScreen />

      <BottleCycleScreen />

      <Container className="infoContainer">
        <Row>
          <Col className="order-2 order-lg-1 mt-4 mt-lg-0" lg={6} xs={12}>
            <div className="flexContainer overlappedImagesContainer">
              <Image
                rounded
                className="mainImage"
                src="/images/home/PakVille-interior03.png"
              />
              <Image
                rounded
                className="secondaryImage"
                src="/images/home/PakVille-interior04.png"
              />
            </div>
          </Col>

          <Col className="order-1 order-lg-2" lg={6} xs={12}>
            <div
              className="flexContainer align-items-center text-center align-items-lg-start text-lg-start"
              style={{ gap: "12px" }}
            >
              <h2>{t("_how_it_works.info.1.title")}</h2>

              <h3>{t("_how_it_works.info.1.section.0.title")}</h3>
              <p>{t("_how_it_works.info.1.section.0.description")}</p>

              <h3>{t("_how_it_works.info.1.section.1.title")}</h3>
              <p>{t("_how_it_works.info.1.section.1.description")}</p>

              <h3>{t("_how_it_works.info.1.section.2.title")}</h3>
              <p>{t("_how_it_works.info.1.section.2.description")}</p>
            </div>
          </Col>
        </Row>
      </Container>

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default Technology;
